<template>
	<div id="app">
		<div v-if="loggedIn" class="app-layout">
			<div class="overlay" :class="{ show: showMobileSidebar }" @click="closeMobileSidebar"></div>
			<nav class="sidebar" :class="{ show: showMobileSidebar }">
				<div class="sidebar-header text-center">
					<b-navbar-brand to="/" class="app-logo">{{$title}}</b-navbar-brand>
				</div>
				<ul class="sidebar-menu nav flex-column">
					<li class="nav-item"><router-link class="nav-link" to="/" exact>Dashboard</router-link></li>
					<li class="nav-item"><router-link class="nav-link" to="/widgets">Widgets</router-link></li>
					<li class="nav-item"><router-link class="nav-link" to="/songs">Song requests</router-link></li>
					<li class="nav-item"><router-link class="nav-link" to="/commands">Commands</router-link></li>
					<li class="nav-item"><router-link class="nav-link" to="/timers">Timers</router-link></li>
					<li class="nav-item"><router-link class="nav-link" to="/urls">URLs</router-link></li>
					<li class="nav-item"><router-link class="nav-link" to="/chatters">Chatters</router-link></li>
					<li class="nav-item"><router-link class="nav-link" to="/settings">Settings</router-link></li>
				</ul>
				<div class="sidebar-footer text-center">
					<b-dropdown block dropup v-if="user?.is_admin" menu-class="w-100" text="Admin">
						<b-dropdown-item to="/admin">Admin</b-dropdown-item>
						<b-dropdown-item to="/admin/services">Services</b-dropdown-item>
						<b-dropdown-item to="/admin/channels">Channels</b-dropdown-item>
						<b-dropdown-item to="/admin/users">Users</b-dropdown-item>
						<b-dropdown-item to="/admin/voices">Voices</b-dropdown-item>
						<b-dropdown-item to="/admin/giftTypes">Gift types</b-dropdown-item>
						<b-dropdown-item to="/admin/categories">Categories</b-dropdown-item>
					</b-dropdown>

					<b-dropdown block dropup :text="user?.username" menu-class="w-100">
						<b-dropdown-item to="/account" active-class="active">Account</b-dropdown-item>
						<b-dropdown-item v-if="isSubUser" @click="popOut">Return to previous user</b-dropdown-item>
						<b-dropdown-item @click="logOut">Sign out</b-dropdown-item>
					</b-dropdown>
				</div>
			</nav>
			<main class="main-content" :class="{ expanded: showMobileSidebar }">
				<div class="top-nav navbar-dark">
					<button class="hamburger-btn" @click="toggleMobileSidebar"><span class="navbar-toggler-icon"></span></button>
					<b-navbar-brand to="/" class="mobile-logo">{{$title}}</b-navbar-brand>
					<div style="width: 30px;"></div>
				</div>
				<b-container class="flex-fill d-flex flex-column" :class="{'overflow-hidden': $route.name == 'Home' || $route.name == 'Songs', 'py-2': $route.name != 'Songs', 'px-0': $route.name == 'Songs' }" :fluid="$route.name == 'Songs'">
					<b-alert variant="secondary" :show="user && !user.email_confirmed">You haven't confirmed your email address. Please click the link received in your inbox.<b-button variant="secondary" size="sm" class="float-right" @click="resendConfirmationCode()">Resend link</b-button><div class="clearfix"></div></b-alert>
					<b-alert variant="danger" :show="user && !user.is_subscribed && $route.path != '/account/billing'">You are not subscribed. Please visit your <router-link class="alert-link" to="/account/billing">billing page</router-link> to enable your account.</b-alert>
					<div class="text-center" v-if="loading>0">
						<b-icon icon="circle-fill" animation="throb" font-scale="4"></b-icon>
					</div>
					<b-alert variant="danger" show v-else-if="error">{{error}}</b-alert>
					<router-view v-else-if="user"/>
					<b-alert variant="danger" show v-else>No userdata</b-alert>
				</b-container>
			</main>
		</div>
		<b-container class="mt-3 mb-3" v-else>
			<b-row>
				<b-col cols="12" md="3" lg="4">
					<a href="/">&laquo; Back to front page</a>
				</b-col>
				<b-col cols="12" md="6" lg="4">
					<h1 class="text-center mb-5"><span style="color: #5df286; text-shadow: 0 0 20px #5df286">Live</span> <span style="color: #eb5dff; text-shadow: 0 0 20px #eb5dff">Joiner</span></h1>
					<div v-if="$route.name == 'Register' || $route.name == 'Confirm' || $route.name == 'Recover'">
						<h5 class="text-center">{{$route.name}}</h5>
						<router-view/>
					</div>
					<b-form @submit.stop.prevent="submitLogin" v-else>
						<h5 class="text-center">Login</h5>
						<b-form-group
							id="login-username-group"
							label="Username:"
							label-for="login-username"
						>
							<b-form-input
								id="login-username"
								v-model="loginForm.username"
								type="text"
								placeholder="Enter username"
								required
							></b-form-input>
						</b-form-group>
						<b-form-group id="login-password-group" label="Password:" label-for="login-password">
							<b-form-input
								id="login-password"
								type="password"
								v-model="loginForm.password"
								placeholder="Enter password"
								required
							></b-form-input>
						</b-form-group>
						<b-alert variant="danger" v-show="loginForm.message" show class="mb-2">{{loginForm.message}}</b-alert>
						<b-row class="mb-2">
							<b-col>
								<b-spinner v-show="loginForm.loading" small label="Loading"></b-spinner>
							</b-col>
							<b-col class="text-right">
								<b-button variant="success" type="submit" class="ml-3">Login</b-button>
							</b-col>
						</b-row>
						<b-row class="mb-2">
							<b-col>
								<router-link to="/register">Register</router-link>
							</b-col>
							<b-col class="text-right">
								<router-link to="/recover">Forgot password?</router-link>
							</b-col>
						</b-row>
					</b-form>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
export default {
	data() { return {
		loading: 0,
		error: null,
		loggedIn: false,
		isSubUser: false,
		loginForm: {
			loading: false,
			username: '',
			password: '',
			message: null,
		},
		user: null,
		showMobileSidebar: false,
		activeMenu: 'dashboard'
	}},
	watch: {
		$route() {
			this.loginForm.loading = false;
			this.loginForm.username = '';
			this.loginForm.password = '';
			this.loginForm.message = '';
		}
	},
	mounted() {
		this.$auth.addEventListener('authChanged', this.authChanged.bind(this))
		this.$auth.loadFromLocalStorage();
		// Handle window resize to close mobile sidebar if screen becomes wider
		window.addEventListener('resize', () => { if(window.innerWidth > 768) this.showMobileSidebar = false });
		this.initSwipeGesture();
	},
	beforeDestroy() {
		this.$auth.removeEventListener('authChanged', this.authChanged.bind(this))
		document.removeEventListener('touchstart', this._onTouchStart);
		document.removeEventListener('touchmove', this._onTouchMove);
		document.removeEventListener('touchend', this._onTouchEnd);
	},
	methods: {
		authChanged(ev) {
			this.loggedIn = ev.detail.isLoggedIn;
			this.isSubUser = ev.detail.isSubUser;
			if(!this.loggedIn) {
				this.user = null;
				return;
			}

			this.reloadUserData();
		},
		async reloadUserData() {
			try {
				this.loading++;
				this.error = null;
				await this.loadUserData();
			} catch(err) {
				this.error = err;
				this.user = null;
				console.error('Could not get user data', err);
			} finally {
				this.loading--;
			}
		},
		async loadUserData() {
			this.user = await this.$api.get('userData');
		},
		submitLogin: function() {
			this.loginForm.loading = true;
			this.loginForm.message = '';
			this.$api.post('auth', {
				username: this.loginForm.username,
				password: this.loginForm.password
			}).then(result => {
				const params = new Proxy(new URLSearchParams(window.location.search), {
					get: (searchParams, prop) => searchParams.get(prop),
				});
				if(params.redirect) {
					this.$auth.store(result.token);
					document.location = params.redirect;
					return;
				}
				this.$auth.load(result.token);
				this.$bvToast.toast('Logged in', {
					title: 'Success',
					variant: 'success',
					solid: true
				});
				this.$bvModal.hide('login-modal');
				this.loginForm.username = '';
				this.loginForm.password = '';
			}).catch(err => {
				console.error(err);
				this.loginForm.message = err;
			}).finally(() => {
				this.loginForm.loading = false;
			});

			return false;
		},
		loginOk(bvModalEvt) {
			bvModalEvt.preventDefault();
			this.submitLogin();
		},
		resetLogin: function() {
			this.loginForm.username = '';
			this.loginForm.password = '';
			this.loginForm.message = '';
		},
		logOut() {
			delete localStorage.username;
			delete localStorage.authToken;
			this.$auth.setToken(null);
		},
		popOut() {
			this.$auth.popToken();
			this.$router.push({ path: `/admin/users` });
		},
		async resendConfirmationCode() {
			try {
				this.loading++;
				this.error = null;
				this.user = await this.$api.post('resendConfirmationCode');
			} catch(err) {
				this.error = err;
			} finally {
				this.loading--;
			}
		},
		toggleMobileSidebar() {
			this.showMobileSidebar = !this.showMobileSidebar;
		},
		closeMobileSidebar() {
			this.showMobileSidebar = false;
		},
		initSwipeGesture() {
			const SIDEBAR_WIDTH = 200;
			let startX = 0, startY = 0, startTime = 0, startOpen = false, swiping = false, locked = false;

			const getSidebar = () => this.$el?.querySelector('.sidebar');
			const getOverlay = () => this.$el?.querySelector('.overlay');

			const setSwipePosition = (translateX) => {
				const s = getSidebar(), o = getOverlay();
				if(!s || !o) return;
				const progress = (SIDEBAR_WIDTH + translateX) / SIDEBAR_WIDTH;
				s.style.transition = 'none';
				s.style.transform = `translateX(${translateX}px)`;
				o.style.transition = 'none';
				o.style.opacity = progress;
				o.style.visibility = progress > 0 ? 'visible' : 'hidden';
			};

			const clearSwipeStyles = () => {
				const s = getSidebar(), o = getOverlay();
				if(!s) return;
				s.style.transition = '';
				s.style.transform = '';
				if(!o) return;
				o.style.transition = '';
				o.style.opacity = '';
				o.style.visibility = '';
			};

			const getTranslateX = (dx) => {
				if(startOpen) return Math.max(-SIDEBAR_WIDTH, Math.min(0, dx));
				return Math.max(-SIDEBAR_WIDTH, Math.min(0, -SIDEBAR_WIDTH + dx));
			};

			this._onTouchStart = (e) => {
				if(window.innerWidth > 768) return;
				startX = e.touches[0].clientX;
				startY = e.touches[0].clientY;
				startTime = Date.now();
				startOpen = this.showMobileSidebar;
				swiping = false;
				locked = false;
			};

			this._onTouchMove = (e) => {
				if(window.innerWidth > 768) return;
				const dx = e.touches[0].clientX - startX;
				const dy = e.touches[0].clientY - startY;

				if(locked) return;
				if(!swiping) {
					if(Math.abs(dx) < 20 && Math.abs(dy) < 20) return;
					if(Math.abs(dy) > Math.abs(dx) * 0.5) { locked = true; return; }
					if(!startOpen && dx < 0) { locked = true; return; }
					if(startOpen && dx > 0) { locked = true; return; }
					swiping = true;
				}

				setSwipePosition(getTranslateX(dx));
			};

			this._onTouchEnd = (e) => {
				if(!swiping) return;
				swiping = false;
				const dx = e.changedTouches[0].clientX - startX;
				const elapsed = Date.now() - startTime;
				const velocity = Math.abs(dx) / elapsed; // px/ms
				const translateX = getTranslateX(dx);
				clearSwipeStyles();
				// Quick flick (>0.3 px/ms) commits in the swipe direction
				if(velocity > 0.3)
					this.showMobileSidebar = dx > 0;
				else
					this.showMobileSidebar = (SIDEBAR_WIDTH + translateX) > SIDEBAR_WIDTH / 3;
			};

			document.addEventListener('touchstart', this._onTouchStart, { passive: true });
			document.addEventListener('touchmove', this._onTouchMove, { passive: true });
			document.addEventListener('touchend', this._onTouchEnd, { passive: true });
		},
		setActiveMenu(menu) {
			this.activeMenu = menu;
			// Close mobile sidebar when menu item is clicked
			this.showMobileSidebar = false;

			// Update active state
			this.$nextTick(() => {
				document.querySelectorAll('.nav-link').forEach(link => {
					link.classList.remove('active');
				});
				event.target.classList.add('active');
			});
		}
	},
}
</script>

<style lang="scss">
@import './plugins/variable.scss';

.app-layout {
	height: 100vh;
	overflow: hidden;

	> .sidebar {
		width: 200px;
		height: 100vh;
		position: fixed;
		left: 0;
		top: 0;
		background: $gray-200;
		transition: transform 0.3s ease;
		display: flex;
		flex-direction: column;
		z-index: 500;

		&.collapsed {
			transform: translateX(-100%);
		}

		> .sidebar-header {
			padding: 10px;
			border-bottom: 1px solid $border-color;
			flex-shrink: 0;

			> .app-logo {
				color: white;
				font-size: 1.5rem;
				text-decoration: none;
				margin-right: 0;
			}
		}
		> .sidebar-menu {
			flex: 1;
			overflow-y: auto;
			padding: 0;
			margin: 0;
			flex-wrap: nowrap;

			.nav-link {
				color: $blue !important;
			}

			.nav-link:hover,
			.nav-link.active,
			.nav-link.active-tree {
				background-color: $gray-600;
				color: white !important;
			}
		}

		> .sidebar-footer {
			text-align: center;
			border-top: 1px solid $border-color;
			flex-shrink: 0;
		}
	}
	.main-content {
		display:flex;
		flex-direction: column;
		margin-left: 200px;
		transition: margin-left 0.3s ease;
		height: 100vh;
		overflow-y: auto;
		&.expanded {
			margin-left: 0;
		}
	}

	.top-nav {
		background: $gray-200;
		padding: 10px 20px;
		display: none;
		align-items: center;
		justify-content: space-between;
	}

	.hamburger-btn {
		background: none;
		border: none;
		font-size: 1.2rem;
	}

	.mobile-logo {
	}

	.overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5);
		backdrop-filter: blur(3px);
		z-index: 400;
		opacity: 0;
		visibility: hidden;
		transition: all 0.3s ease;
	}

	.overlay.show {
		opacity: 1;
		visibility: visible;
	}

	@media (max-width: 768px) {
		.sidebar {
			transform: translateX(-100%);
			&.show {
				transform: translateX(0);
			}
		}

		.main-content {
			margin-left: 0;
		}

		.top-nav {
			display: flex;
		}
	}
}
</style>
